import AddUserDialog from './AddUserDialog';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import GS from '../../grafsync/grafsync';
import ActionText from '../ActionText';
import Errored from '../Errored';
import Loading from '../Loading';
import Paging from '../Paging';
import PagingFilter from '../PagingFilter';
import { globalStyles as styles } from '../style/gstheme';
import { MAX_USERNAME_LENGTH } from '../utils/constants';
import { makeCancelable } from '../utils/utils';
import UserCard from './UserCard';

class UserStructure extends Component {

  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      users: [],
      text: "",
      page: 1,
      pageSize: 8,
      noneFound: false,
      noResults: true,
      pageCount: null,
      isErrored: null
    };
    this.cancellable = null;
  }

  componentDidMount() {
    this.handlePageChange();
  }

  filterLabel = (event) => this.setState({ text: event.target.value });

  handlePageRefresh = () => this.setState({ text: "" }, () => this.handlePageChange(this.state.page));

  handleFilterChange = (text) => {
    this.props.onUpdate();
    this.setState({ text: text.trim(), page: 1 }, () => this.handlePageChange(this.state.page));
  };

  handlePageChange = async (page = 1) => {
    this.setState(
      { isLoading: true },
      () => {
        let payload = {
          search: [],
          page: page,
          pageSize: this.state.pageSize,
          sort: ["http://schema.org/familyName"],
        };
        if (this.state.text) payload.search = [{
          predicate: ["https://graphifi.com/schema/accesscontrol/username", "http://schema.org/givenName", "http://schema.org/familyName"],
          value: this.state.text,
          isExactMatch: false
        }];
        this.doSearch(payload)
          .promise
          .then(data => {
            if (this.cancellable && this.cancellable.isCancelled()) return;
            if (data.results && data.results.length > 0) {
              const unsortedUsers = [...data.results];
              const sortedUsers = unsortedUsers.sort(function (a, b) {
                const orderA = a.givenName && a.familyName ? a.givenName + a.familyName + a.username : a.username;
                const orderB = b.givenName && b.familyName ? b.givenName + b.familyName + b.username : b.username;
                if (orderA.toLowerCase() < orderB.toLowerCase()) return -1;
                if (orderA.toLowerCase() > orderB.toLowerCase()) return 1;
                return 0;
              });
              this.setState({
                users: sortedUsers,
                page,
                noResults: false,
                noneFound: false,
                pageCount: data.pageCount,
                isLoading: false
              });
            }
            else {
              this.setState({
                isLoading: false,
                page: 1,
                pageCount: 1,
                noneFound: true,
                noResults: false,
              });
            }
          })
          .catch((e) => {
            if (this.cancellable && !this.cancellable.isCancelled()) this.setState({ isErrored: e });
          });
      });
  };

  doSearch(payload) {
    this.cancellable = makeCancelable(GS.userSearch(payload));
    return this.cancellable;
  }

  componentWillUnmount() {
    if (this.cancellable) this.cancellable.cancel();
  }

  sortGroups(users) {
    return users.sort(function (a, b) {
      let orderA = a.familyName + a.givenName;
      let orderB = b.familyName + b.givenName;
      if (orderA < orderB) return -1;
      if (orderA > orderB) return 1;
      return 0;
    });
  }

  render() {

    const { isLoading, users, page, pageCount, isErrored, noneFound, text } = this.state;
    const { onSelectUser, classes, altered, selectedUser, displayUser } = this.props;

    if (isErrored) return <Errored data={isErrored} />;
    if (isLoading) return <Loading />;

    return (
      <div className={classes.controlPanel}>
        <div className={classes.controlPanelInner}>
        <div data-test="add-user" className={classes.controlPanelAdd}>
          <AddUserDialog displayUser={displayUser} />
        </div>
        <div className={classes.controlPanelSearch}>
          <PagingFilter
            handleFilterChange={this.handleFilterChange}
            placeholder="Enter part of user's name/username"
            maxLength={MAX_USERNAME_LENGTH}
            text={text}
            altered={altered} />
        </div>
        </div>
        <div style={{ clear: 'both', marginTop: '10px' }}>
          <Paging page={page} pageCount={pageCount} handlePageChange={this.handlePageChange} />
        </div>
        <div data-test="users-list" className={classes.tree} style={pageCount > 1 ? { top: '190px' } : { top: '154px' }}>
          {noneFound || !users ?
            <ActionText offset="50px" format="result">No results.</ActionText>
            :
            users.map(user =>
              <UserCard
                isSelected={selectedUser === user.id}
                key={user.id}
                user={user}
                onSelectUser={onSelectUser}
              />)
          }
        </div>
      </div>
    );
  }
}

UserStructure.propTypes = {
  classes: PropTypes.object,
  blockedChanges: PropTypes.object,
  altered: PropTypes.bool,
  displayUser: PropTypes.func,
  selectedUser: PropTypes.string,
  onUpdate: PropTypes.func.isRequired,
  onSelectUser: PropTypes.func.isRequired
};

export default withStyles(styles)(UserStructure);